@import 'vars';

.header {
  display: flex;
  min-width: 150px !important;
  padding-left: 10px !important;
  padding-right: 10px !important;
  height: 40px !important;
  min-height: 40px !important;
  width: 100% !important;
  pointer-events: none;
  gap: 2px;
  justify-content: center;
  flex-direction: column;

  &--with-subtitle {
    height: 60px !important;
    min-height: 60px !important;
  }

  &__subtitle {
    line-height: $line-height-small;
  }
}
